import React from "react";
import { EntityList } from "@/components/shared/entity/EntityList";
import { useTicketHooks } from "@/features/tickets/hooks/ticket-hooks";
import { getEntityTableConfig } from "@/lib/entity-registry";
import type { Tickets } from "@/src/gql/graphql";

const TICKET_CONFIG = getEntityTableConfig<Tickets>("tickets");

export interface AdvancedTicketListProps {
  filters?: Record<string, any>;
}

const AdvancedTicketList: React.FC<AdvancedTicketListProps> = ({ filters }) => {
  const ticketHooks = useTicketHooks();

  return (
    <EntityList
      entityName="tickets"
      config={TICKET_CONFIG}
      hooks={ticketHooks}
      filters={filters}
      storageKey="advanced-tickets-column-preferences"
      title={undefined}
      description={undefined}
    />
  );
};

export { AdvancedTicketList };
